const enumFilterCapitalize = (value) => {
    if (value === 'ELETRONICA') {
        return 'Eletrônica'
    }
    const name = value.toLowerCase()
    return name.charAt(0).toUpperCase() + name.slice(1)
}

export default enumFilterCapitalize
